import 'slick-carousel';

class FoamPage {
    constructor() {
        this.setupMenus();
        this.setupDropdowns();
        this.setupSlider();
    }

    setupMenus() {
        var form = $(".foam-sub-nav .search-form");
        if (form.length) {
            $(".foam-sub-nav .search-form").append("<input type='hidden' name='post_type' value='post' />");
        }

        $("#foam-categories-toggle").click(function() {
            $("#foam-categories-list").toggle();
        });
        $("#foam-submenu .menu-item.menu-item-has-children").click(function(el){
            $(el.currentTarget).toggleClass("expanded");
        });
    }

    setupDropdowns() {
        var dropdown = $("#foam-category-dropdown");
        var list = $("#foam-categories-list .sidemenu > .cat-item");
        $(list).each(function(i, v) {
            var link = $(v).children("a");
            $(dropdown).append(`<option value="${link.attr("href")}">${link.text()}</option>`);
        });

        $(dropdown).on('change', function() {
            window.location = this.value;
        });
    }

    setupSlider() {
        var slider = $(".foam-slider");
        if (slider.length > 0) {
            $(slider).slick({
                autoplay: true,
                autoplaySpeed: 3000,
                dots: true,
                infinite: true,
            });
        } 
    }
}

export default FoamPage;